import { mapSuggest } from './../../mapper/suggest';
import { HotelService, CarService, FlightService } from './index';
import { map, mergeMap } from 'rxjs/operators';
import 'typescript-array-extensions';
import { from } from 'rxjs';
import { Suggest } from 'types';

export namespace SuggestService {
  export const fetchSuggests = (requestBody: any, type: Suggest.Type) => {
    if (type == Suggest.Type.HOTEL) {
      return HotelService.hotelSuggest(requestBody).pipe(
        map((a) => a.data.map((b) => mapSuggest(b, type)))
      );
    } else if (type == Suggest.Type.FLIGHT) {
      return FlightService.autosuggest(requestBody).pipe(
        map((a) =>
          a
            .filter((b) => {
              const iata = b.iataCode
                ? b.iataCode
                : b.airportInformation
                ? b.airportInformation.iataCode
                : undefined;
              return b.type != 'PLACE_TYPE_COUNTRY' && iata;
            })
            .map((b) => mapSuggest(b, type))
        )
      );
    } else {
      return CarService.carSuggests(requestBody.q).pipe(
        map((a) => a.map((b) => mapSuggest(b, type)))
      );
      // return from(CarsSuggestsPersistenceService.getInstance().search(requestBody.q)).pipe(
      //   map((a) => a.map((b) => mapSuggest(b, type)))
      // );
    }
  };
}
